import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  state: {
    selectedMealType: null,
    preferedTerminalSummaryTableMode:
      JSON.parse(localStorage.getItem("preferedTerminalSummaryTableMode")) || "summary",
  },

  mutations: {
    setSelectedMealType(state, selectedMealType) {
      state.selectedMealType = selectedMealType;
    },

    resetState(state) {
      state.selectedMealType = null;
    },

    setPreferedTerminalSummaryTableMode(state, preferedTerminalSummaryTableMode) {
      localStorage.setItem(
        "preferedTerminalSummaryTableMode",
        JSON.stringify(preferedTerminalSummaryTableMode),
      );

      state.preferedTerminalSummaryTableMode = preferedTerminalSummaryTableMode;
    },

    revokePreferedTerminalSummaryTableMode() {
      localStorage.removeItem("preferedTerminalSummaryTableMode");
    },
  },

  actions: {
    async scanCard(_, data) {
      return await axios
        .post(`${API_URL}/terminal/scanCard/${data.date}/${data.cardNumber}`, {
          mealTypesIds: data.mealTypesIds,
        })
        .catch((err) => {
          if (!err.response || !err.response.data) {
            throw new Error("Error occurred while processing your request.");
          }

          return err.response;
        });
    },

    async markCalendarDayMealTypeAsScanned(_, { calendarDayId, mealTypesIds }) {
      const response = await axios.post(
        `${API_URL}/terminal/calendarDays/${calendarDayId}/markAsScanned`,
        {
          mealTypesIds,
        },
      );

      if (!response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response;
    },

    unsetPreferedTerminalSummaryTableMode({ commit }) {
      commit("revokePreferedTerminalSummaryTableMode");
    },

    async updatePreferedTerminalSummaryTableMode({ commit }) {
      let preferedTerminalSummaryTableMode =
        JSON.parse(localStorage.getItem("preferedTerminalSummaryTableMode")) || "details";

      commit("setPreferedTerminalSummaryTableMode", preferedTerminalSummaryTableMode);
    },

    async getSubjectByCardNumber(_, cardNumber) {
      const response = await axios
        .get(`${API_URL}/terminal/subjects/cardNumber/${cardNumber}`)
        .catch((err) => {
          if (!err.response || !err.response.data) {
            throw new Error("Error occurred while processing your request.");
          }

          return err.response;
        });

      return response.data;
    },

    async markPresences(
      _,
      { subjectId, subjectType, presencesData, addManipulationFee = false, manipulationFee = null },
    ) {
      const res = await axios.post(`${API_URL}/terminal/${subjectType}/${subjectId}/presences`, {
        calendarDaysData: presencesData,
        addManipulationFee: addManipulationFee,
        manipulationFee: manipulationFee,
      });

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },
  },
};
